import styled from 'styled-components'

export const Container = styled.section`
  font-family: "Montserrat", sans-serif;
`